import { Dispatch } from 'redux'
import { IGetShiftsThunkParams } from 'models/Shift'

import { API } from 'network'
import {
  GetUpshifterRecommendedShifts,
  GetUpshifterRecommendedShiftsErrors,
  UpshifterRecommendedShiftsFetching,
  UpshifterRecommendedShiftsSetHasMore,
  ClearUpshifterRecommendedShiftsReducer,
  GetUpshifterRecommendedShiftsWithoutConcat,
} from './actions'

export type TUpshifterRecommendedShiftsActions =
  | ReturnType<typeof GetUpshifterRecommendedShifts>
  | ReturnType<typeof GetUpshifterRecommendedShiftsWithoutConcat>
  | ReturnType<typeof GetUpshifterRecommendedShiftsErrors>
  | ReturnType<typeof UpshifterRecommendedShiftsFetching>
  | ReturnType<typeof ClearUpshifterRecommendedShiftsReducer>
  | ReturnType<typeof UpshifterRecommendedShiftsSetHasMore>

export const getUpshifterRecommendedShifts = ({
  params,
  preventConcatenate,
}: IGetShiftsThunkParams) => async (
  dispatch: Dispatch<TUpshifterRecommendedShiftsActions>,
) => {
  if (!params?.page) {
    dispatch(ClearUpshifterRecommendedShiftsReducer())
    dispatch(UpshifterRecommendedShiftsSetHasMore(true))
  }
  dispatch(UpshifterRecommendedShiftsFetching(true))
  try {
    const response = await API.Shifts.getShifts(params)
    if (preventConcatenate) {
      dispatch(GetUpshifterRecommendedShiftsWithoutConcat(response))
    } else {
      dispatch(GetUpshifterRecommendedShifts(response))
    }
    return response
  } catch (error) {
    dispatch(
      GetUpshifterRecommendedShiftsErrors({
        code: error.code,
        message: error.message,
      }),
    )

    return error
  } finally {
    dispatch(UpshifterRecommendedShiftsFetching(false))
  }
}
